import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axiosInstance from '../utils/axiosConfig';
import { useAuth } from './AuthContext';

interface DestekBildirimContextType {
    bildirimSayisi: number;
    yenile: () => void;
}

const DestekBildirimContext = createContext<DestekBildirimContextType>({
    bildirimSayisi: 0,
    yenile: () => {}
});

export const DestekBildirimProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user } = useAuth();
    const [bildirimSayisi, setBildirimSayisi] = useState(0);

    const yenile = useCallback(async () => {
        if (!user?.kullaniciID) return;
        try {
            const res = await axiosInstance.get(`/api/Destek/bildirim-sayisi?kullaniciId=${user.kullaniciID}`);
            setBildirimSayisi(res.data.sayi ?? 0);
        } catch {
            // sessiz hata
        }
    }, [user?.kullaniciID]);

    useEffect(() => {
        if (!user?.kullaniciID) return;
        yenile();
        // Her 2 dakikada bir kontrol et
        const interval = setInterval(yenile, 120_000);
        return () => clearInterval(interval);
    }, [user?.kullaniciID, yenile]);

    return (
        <DestekBildirimContext.Provider value={{ bildirimSayisi, yenile }}>
            {children}
        </DestekBildirimContext.Provider>
    );
};

export const useDestekBildirim = () => useContext(DestekBildirimContext);
